import "../css/app.scss"
import "preline"

// Gallery

document.addEventListener("DOMContentLoaded", function () {
    const gallery = document.querySelector("#lightgallery")
    if (gallery) {
        lightGallery(gallery, {
            mode: "lg-slide",
        })
    }
    const singleGallery = document.querySelector("#lightgallery2")
    if (singleGallery) {
        lightGallery(singleGallery, {
            mode: "lg-slide",
        })
    }
})
